const JAVASCRIPT_FILE_TYPE = 'js';
const CSS_FILE_TYPE = 'css';
type FileType = typeof JAVASCRIPT_FILE_TYPE | typeof CSS_FILE_TYPE;

async function attemptToLoadExternalCodeFile(url: string, fileType: FileType) {
  await new Promise<void>((resolve, reject) => {
    const htmlElementType = fileType === JAVASCRIPT_FILE_TYPE ? 'script' : 'link';
    const htmlElement = document.createElement(htmlElementType);

    if (htmlElement instanceof HTMLScriptElement) {
      document.body.appendChild(htmlElement);

      htmlElement.src = url;
      htmlElement.type = 'text/javascript';
      htmlElement.async = false;
      htmlElement.defer = false;
    } else {
      document.head.appendChild(htmlElement);

      htmlElement.href = url;
      htmlElement.type = 'text/css';
      htmlElement.rel = 'stylesheet';
    }

    htmlElement.onload = () => { resolve(); };
    htmlElement.onerror = () => { reject(); };
  });
}

export async function loadExternalCodeFile(url: string, numAttempts: number, fileType: FileType) {
  // TODO: make sure url is a valid url and make sure numAttempts is an integer greater than 0

  for (let i = 0; i < numAttempts; i++) {
    try {
      await attemptToLoadExternalCodeFile(url, fileType);
      return;
    } catch (e) {
      window.sc3WorkbenchLogger.error(`Failed to load external code file with url: ${url} to document body (attempt number ${i + 1} of ${numAttempts}).`, e);

      if (i === numAttempts - 1) {
        throw e;
      }
    }
  }
}
